<div class="inline-block">
  <wvr-card-component
    class="swatches"
    [panelFormat]="'solid'"
    [themeVariant]="tv.key"
    *ngFor="let tv of currentTheme | async | keyvalue : originalOrdering; trackBy:index">
    <template card-header>
      <h3>{{tv.key}}</h3>
    </template>
    <template card-content>
      {{tv.value.baseColor}}
    </template>
  </wvr-card-component>
</div>
